import React from 'react';
import type Locale from 'date-fns';

import Text from '../Text';
import StaticDatePicker from '../StaticDatePicker';
import Box from '../Box';
import { formatDate } from '../../utils/dateUtils';
import { Question } from '../../types/DataTypes';
import { AssessmentResultAnswer } from '../../types';

type Props = {
  question: Question;
  answer: AssessmentResultAnswer;
  onAnswerChange: (question: Question, updatedAnswer: AssessmentResultAnswer) => void;
  disabled?: boolean;
  locale?: Locale;
}

const DateField: React.FC<Props> = (props: Props) => {
  const {
    question, onAnswerChange, answer, disabled, locale,
  } = props;

  const handleDateChange = (date: Date) => onAnswerChange(question, {
    type: question.questionType,
    answers: [{
      text: date.toISOString(),
      uid: '',
    }],
  });

  const dateFromAnswers = answer.answers.length && new Date(answer.answers[0].text);
  const dateInPicker = dateFromAnswers || new Date();

  return (
    <Box width="90%" maxWidth={300}>
      {(!disabled
      && <StaticDatePicker selectedDate={dateInPicker} onChange={handleDateChange} locale={locale} />
      )}
      {(disabled
      && (
        <Text>
          {dateFromAnswers ? formatDate(dateFromAnswers) : 'No date selected'}
        </Text>
      )
      )}
    </Box>
  );
};

export default DateField;
